import { Injectable } from '@angular/core';

import moment from 'moment';
import { Service } from '@shared/service/models';

@Injectable({ providedIn: 'root' })
export class DateService {
  //TODO: the same as schedule-provider.service-> checkServicesDuration
  checkServicesDuration(services: Service[], selectedServiceIds: string[]): number {
    return selectedServiceIds.reduce((result, serviceId) => {
      const currentService = services.find(service => service._id === serviceId);
      result += currentService?.duration.miliseconds || 0;
      return result;
    }, 0);
  }

  convertTimestampToHour(time, timezone) {
    return time.map((i) => {
      if (i === '') {
        return i;
      }
      const date = moment(Number(i)).tz(timezone);
      const hours = date.format('h');
      const minutes = date.format('mm');
      const meridiem = date.format('A');
      return {
        hours,
        minutes,
        meridiem,
        timestamp: i
      };
    });
  }
}
